import { addMoney } from '@shared/lib/money';
import { FareFamilyPriceFragment, SegmentFragment } from '@websky/graphql';
import { SegmentWithTransferFragment } from '@websky/graphql';
import { SelectedFare } from './types';

export const getNextSegment = (segments: SegmentWithTransferFragment[], index: number): SegmentFragment =>
	segments[index + 1]?.segment;

export const getCheapestFlightInCombination = (
	fares: FareFamilyPriceFragment,
	selectedFares: SelectedFare[]
): FareFamilyPriceFragment['prices'][0] | null => {
	if (selectedFares.length === 0) {
		return fares.prices?.[0] ?? null;
	}

	const lastSelectedFare = selectedFares[selectedFares.length - 1];

	const lastSelectedFareMap = new Map<string, number>();
	lastSelectedFare?.prices?.forEach(price => {
		if (price.flight?.id && price.price) {
			lastSelectedFareMap.set(price.flight.id, price.price.amount);
		}
	});

	let minSum = Infinity;
	let minPrice = fares.prices?.[0] ?? null;

	fares.prices?.forEach(price => {
		if (price?.flight?.id && price?.price && lastSelectedFareMap.has(price.flight.id)) {
			const totalAmount = addMoney(price.price, {
				amount: lastSelectedFareMap.get(price.flight.id),
				currency: price.price.currency
			}).amount;

			if (totalAmount < minSum) {
				minSum = totalAmount;
				minPrice = price;
			}
		}
	});

	return minPrice;
};
